import Serializer from "../../serializer";
import {QuestionModel} from "./models";
import {JSONAPIDocument} from "json-api-serializer";
import {IMSTArray} from "mobx-state-tree";

export function deserializeQuestions(data: JSONAPIDocument): IMSTArray<typeof QuestionModel> {
  return Serializer.deserialize("questions", data);
}
export function deserializeQuestion(data: JSONAPIDocument): IMSTArray<typeof QuestionModel> {
  return [Serializer.deserialize("questions", data)] as IMSTArray<typeof QuestionModel>;
}
